import { useState, useEffect, useCallback } from 'react';
import { Phone, MessageCircle, X } from 'lucide-react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

export const FloatingCTA = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  const handleScroll = useCallback(() => {
    setIsVisible(window.scrollY > 400);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.8 }}
          className="fixed bottom-6 right-6 z-40 flex flex-col items-end gap-3"
          data-testid="floating-cta"
        >
          {/* Expanded Options */}
          <AnimatePresence>
            {isExpanded && (
              <>
                <motion.div
                  initial={{ opacity: 0, y: 20, scale: 0.8 }}
                  animate={{ opacity: 1, y: 0, scale: 1 }}
                  exit={{ opacity: 0, y: 20, scale: 0.8 }}
                  transition={{ delay: 0.1 }}
                >
                  <Link
                    to="/contact"
                    className="flex items-center gap-2 px-4 py-3 bg-white text-burgundy rounded-full shadow-lg hover:shadow-xl transition-all font-semibold text-sm"
                    data-testid="floating-contact-btn"
                  >
                    <MessageCircle className="w-5 h-5" />
                    <span>Demander un essai</span>
                  </Link>
                </motion.div>
                <motion.div
                  initial={{ opacity: 0, y: 20, scale: 0.8 }}
                  animate={{ opacity: 1, y: 0, scale: 1 }}
                  exit={{ opacity: 0, y: 20, scale: 0.8 }}
                >
                  <a
                    href="tel:+33649523778"
                    className="flex items-center gap-2 px-4 py-3 bg-teal text-white rounded-full shadow-lg hover:shadow-xl transition-all font-semibold text-sm"
                    data-testid="floating-phone-btn"
                  >
                    <Phone className="w-5 h-5" />
                    <span>Appeler maintenant</span>
                  </a>
                </motion.div>
              </>
            )}
          </AnimatePresence>

          {/* Main Button */}
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => setIsExpanded(!isExpanded)}
            className={`w-14 h-14 rounded-full shadow-xl flex items-center justify-center transition-all ${
              isExpanded ? 'bg-gray-700' : 'bg-burgundy hover:bg-burgundy-600'
            }`}
            aria-label={isExpanded ? 'Fermer' : 'Contact rapide'}
            data-testid="floating-main-btn"
          >
            {isExpanded ? (
              <X className="w-6 h-6 text-white" />
            ) : (
              <MessageCircle className="w-6 h-6 text-white" />
            )}
          </motion.button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
